<template>
  <div class="vessel-assessment">
    <vs-table v-if="data">
      <template>
        <vs-tr class="rating">
          <vs-th class="main-th" rowspan="2">Rating</vs-th>
          <vs-td class="w-1/2">
            <vs-radio v-model="data.rating" vs-value="X">X</vs-radio>
          </vs-td>
          <vs-td class="pl-8">
            <vs-radio v-model="data.rating" vs-value="0">0</vs-radio>
          </vs-td>
          <vs-td class="pl-8">
            <vs-radio v-model="data.rating" vs-value="1">1</vs-radio>
          </vs-td>
          <vs-td class="pl-8">
            <vs-radio v-model="data.rating" vs-value="2">2</vs-radio>
          </vs-td>
          <vs-td class="pl-8">
            <vs-radio v-model="data.rating" vs-value="3">3</vs-radio>
          </vs-td>
          <vs-td class="pl-8">
            <vs-radio v-model="data.rating" vs-value="4">4</vs-radio>
          </vs-td>
          <vs-td class="pl-8">
            <vs-radio v-model="data.rating" vs-value="5">5</vs-radio>
          </vs-td>
        </vs-tr>
        <vs-tr>
          <vs-td>Not Applicable</vs-td>
          <vs-td class="bg-light-pink">Unexamined</vs-td>
          <vs-td class="bg-orange">Unsatisfactory</vs-td>
          <vs-td class="bg-lemon">Poor</vs-td>
          <vs-td class="bg-light-blue">Serviceable</vs-td>
          <vs-td class="bg-teal">Good</vs-td>
          <vs-td class="bg-light-green">Excellent</vs-td>
        </vs-tr>
        <vs-tr>
          <vs-th class="main-th">Description</vs-th>
          <vs-td>Not on this vessel</vs-td>
          <vs-td class="bg-light-pink">Unexamined</vs-td>
          <vs-td class="bg-orange">Significant deficiencies</vs-td>
          <vs-td class="bg-lemon">Requiring significant corrective measures starting soonest</vs-td>
          <vs-td class="bg-light-blue">Basic sustainable operational condition</vs-td>
          <vs-td class="bg-teal">Well run, maintained & presented. (Some improvement possible)</vs-td>
          <vs-td class="bg-light-green">Superior condition in all respects</vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div class="mt-4 text-right">
      <vs-button
        class="vs-component vs-button vs-button-warning vs-button-filled"
        color="warning"
        :disabled="button_loading"
        button="submit"
        @click="saveData()"
      >{{ $t('labels.save_data') }}</vs-button>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      radios1: "NA",
      data: ""
    };
  },
  props: ["consultantId", "serviceId"],
  computed: {},
  mounted() {
    this.getVesselData();
  },
  methods: {
    async getVesselData() {
      let input = {
        project_id: this.$route.params.id,
        consultant_id: this.consultantId,
        service_id: this.serviceId
      };
      let response = await this.getHTTPPostResponse(
        "vessel-assessment/list",
        input
      );
      if (response) {
        this.data = response.data.vessel_assessment[0];
      }
    },
    async saveData() {
      let input = {
        id: this.data.id,
        project_id: this.$route.params.id,
        consultant_id: this.consultantId,
        service_id: this.serviceId,
        rating: this.data.rating
      };
      let response = await this.getHTTPPostResponse(
        "vessel-assessment/update",
        input,
        "",
        true
      );
    }
  }
};
</script>
<style scoped>
td {
  width: 220px !important;
  text-align: center;
  color: #000;
}
.main-th {
  background-color: rgba(var(--vs-dark), 1);
  color: #fff !important;
  font-weight: 600;
}
.bg-orange {
  background: #ec6400 !important;
}
.bg-lemon {
  background: #fcff98;
}

.bg-light-blue {
  background: #cbfeff;
}
.bg-teal {
  background: #5ccccc;
}
.bg-light-green {
  background: #6aff00;
}
.bg-light-pink {
  background: pink;
}
</style>
